import { Component, OnInit } from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { Product, Report, RowActions, SelectionAction } from '../../../../admin/report/report';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';
import { ModalData } from '../../../../admin/action/action';
import { TitledModalWithContentService } from '../../../../../shared/services/titled-modal-with-content.service';
import { FetchQuickCashDataService } from './services/fetch-quick-cash-data.service';
import { CongratulationComponent } from '../../../../../shared/components/congratulation/congratulation.component';
import { GetFilteredProductsService } from './services/get-filtered-products.service';
import { ProductActionsDelete } from './services/action-products-delete.service';
import { ProductActionsPublish } from './services/action-products-publish.service';
import { ProductActionsUnpublish } from './services/action-products-unPublish.service';
import { ProductRoutes,ProductTypes, ProductTypesAr } from '../../../../../shared/product/productTypes';
import { LanguageService } from "../../../../../shared/services/language.service";
import { CustomToastService } from "src/app/shared/services/custom-toast.service";

@Component({
  selector: 'app-product-management',
  templateUrl: './product-management.component.html',
  styleUrls: ['./product-management.component.scss']
})
export class ProductManagementComponent implements OnInit {
  productTypeMap: any = {};

  productStatus: any = {};

  tableColumns: string[] = [
    "productName",
    "productTypeName",
    "productStatus",
    "creation",
    "productExpiry",
    "visitedCount",
    "createdBy",
  ];

  displayTableColumns = {};

  selection = new SelectionModel<Product>(true, []);
  loading = false;
  totalNumberOfRecords = 0;
  productManagementReportData: any[] = [];

  filterField;
  requestBody: Report = {};
  selectionActions: SelectionAction[] = [];
  reportName: string = '';

  rowActions: RowActions[] = [];

  constructor(
    private translate: TranslateService,
    public getFilteredProductsService: GetFilteredProductsService,
    private DeleteProductService: ProductActionsDelete,
    private PublishProductService: ProductActionsPublish,
    private modal: TitledModalWithContentService,
    private UnPublishProductService: ProductActionsUnpublish,
    public dialog: MatDialog,
    private router: Router,
    private quickFawryInfo: FetchQuickCashDataService,
    private languageService: LanguageService,
    private customToast: CustomToastService,
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    try {
      this.getFilteredProductsService.activateLoader();
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10
      };
      this.updateTable();
    } catch (error) {
      console.log(error);
    }
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'إدارة المنتجات';
    this.productTypeMap = {
      1: "المنتج",
      2: "الفاتورة",
      3: "الفعاليات",
      4: "الدفع السريع",
      6: "النقد السريع"
    };

    this.productStatus = {
      0: "غير منشورة",
      1: "منشورة"
    };

    this.displayTableColumns = {
      productName: "الإسم",
      productTypeName: "النوع",
      productStatus: "الحالة",
      creation: "تاريخ الإنتاج",
      productExpiry: "تاريخ انتهاء الصلاحية",
      visitedCount: "عدد الزوار",
      createdBy: "تم بواسطة"
    };

    this.filterField = [
      {
        filterFieldName: "published",
        filterDisplayName: "الحالة",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "منشورة", value: "1" },
          { key: "غير منشورة", value: "0" }
        ]
      },
      {
        filterFieldName: "expired",
        filterDisplayName: "انتهاء صلاحية المنتج",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "منتهي الصلاحية", value: "1" },
          { key: "غير منتهي الصلاحية", value: "0" }
        ]
      },
      {
        filterFieldName: "productTypeId",
        filterDisplayName: "نوع المنتج",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "المنتج المادى", value: "1" },
          { key: "الفاتورة", value: "2" },
          { key: "الفعاليات", value: "3" },
          { key: "الدفع السريع", value: "4" },
          { key: "النقد السريع", value: "6" },
          { key: "الاشتراك", value: "7" },
          { key: "خدمة قسّطلي السريعة", value: "9" },
          { key: "النتيجة", value: "11" },
          { key: "حجوزات", value: "13" }

        ]
      }
    ];

    this.rowActions = [
      {
        actionName: "معاينة",
        actionType: "icon",
        actionClass: "btn-default mr-2",
        iconClass: "fa-eye",
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash']
      },
      {
        actionName: "تعديل",
        actionType: "icon",
        actionClass: "btn-info mr-2",
        iconClass: "fa-edit"
      },
      {
        actionName: "مشاركة",
        actionType: "icon",
        actionClass: "btn-primary",
        iconClass: "fa-share",
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash']
      }
    ];

    this.selectionActions = [
      {
        actionName: "مسح",
        actionValue: "delete",
        actionType: "Button",
        actionClass: "btn-outline-danger"
      },
      {
        actionName: "منشورة",
        actionValue: "publish",
        actionType: "Button",
        actionClass: "btn-primary"
      },
      {
        actionName: "غير منشورة",
        actionValue: "unpublish",
        actionType: "Button",
        actionClass: "btn-outline-warning"
      }
    ];
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Manage Products';
    this.productTypeMap = {
      1: "physical",
      2: "invoice",
      3: "event",
      4: "Quick Payment",
      // 5: "Quick Fawry",
      6: "Quick Cash"
    };

    this.productStatus = {
      0: "Un Published",
      1: "Published"
    };

    this.displayTableColumns = {
      productName: "Name",
      productTypeName: "Type",
      productStatus: "Status",
      creation: "Created at",
      productExpiry: "Expires in",
      visitedCount: "Visitor Count",
      createdBy: "Created By",
    };

    this.filterField = [
      {
        filterFieldName: "published",
        filterDisplayName: "Status",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "Published", value: "1" },
          { key: "Unpublished", value: "0" }
        ]
      },
      {
        filterFieldName: "expired",
        filterDisplayName: "Product Expiry",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "Expired", value: "1" },
          { key: "Not Expired", value: "0" }
        ]
      },
      {
        filterFieldName: "productTypeId",
        filterDisplayName: "Product Type",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "Physical Product", value: "1" },
          { key: "Invoice", value: "2" },
          { key: "Event", value: "3" },
          { key: "Quick Payment", value: "4" },
          { key: "Quick Cash", value: "6" },
          { key: "Subscription", value: "7" },
          // { key: "Quick Qassatly", value: "9"},
          { key: "Calendar", value: "11" },
          { key: "Reservation", value: "13" }

        ]
      }
    ];

    this.rowActions = [
      {
        actionName: "View",
        actionType: "icon",
        actionClass: "btn-default mr-2",
        iconClass: "fa-eye",
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash']
      },
      {
        actionName: "Edit",
        actionType: "icon",
        actionClass: "btn-info mr-2",
        iconClass: "fa-edit"
      },
      {
        actionName: "Share",
        actionType: "icon",
        actionClass: "btn-primary",
        iconClass: "fa-share",
        actionDisableEnableField: 'productTypeName',
        actionDisableValues: ['Quick Cash']
      }
    ];

    this.selectionActions = [
      {
        actionName: "Delete",
        actionValue: "delete",
        actionType: "Button",
        actionClass: "btn-outline-danger"
      },
      {
        actionName: "Publish",
        actionValue: "publish",
        actionType: "Button",
        actionClass: "btn-primary"
      },
      {
        actionName: "Unpublish",
        actionValue: "unpublish",
        actionType: "Button",
        actionClass: "btn-outline-warning"
      }
    ];
  }

  isExpired(element: any) {
    return element.expired === true;
  }

  getProductValueByFieldName(fieldName: any, productFieldValues: any): any {
    const allFields: Array<FieldValueModel> = productFieldValues;
    for (const fieldValue of allFields) {
      if (fieldValue.Field?.name === fieldName) {
        return fieldValue.fieldValue;
      }
    }
    return undefined;
  }

  async rowActionClicked(event: any) {
    if (event.action === "View" || event.action === 'معاينة') {
      if (event.key.productTypeId === 6) {
        await this.viewQuickCash(event.key.code);
      } else {
        this.view(event.key);
      }
    } else if (event.action === "Edit" || event.action === 'تعديل') {
      this.edit(event.key);
    } else if (event.action === "Share" || event.action === 'مشاركة') {
      this.openCongratulationDialoug(event.key);
    }
  }

  private async viewQuickCash(code: any) {
    this.quickFawryInfo.setParams({ code });
    try {
      const result = await this.quickFawryInfo.make();

      this.modal.open({
        title: "Quick Cash Info",
        content: `Quick Cash Reference Number: ${result.providerRefNum
          }, Status: ${result.status} with Amount: ${result.amount}
                  for Buyer Name: ${result.buyerFirstName}  and Email: ${result.email} and his Phone: ${result.buyerMobile} `,
        closeButtonName: "Close"
      });
      //console.log(result);
    } catch (err) {
      console.log(err);
    }
  }

  edit(product: any) {
    if (
      product.productTypeName == ProductTypes.quickPayment ||
      product.productTypeName == ProductTypesAr.quickPayment ||
      product.productTypeName == ProductTypes.quickQassatly ||
      product.productTypeName == ProductTypesAr.quickQassatly ||
      product.productTypeName == ProductTypes.quickCash ||
      product.productTypeName == ProductTypesAr.quickCash
    ) {
      this.customToast.addFailedToast(
        this.translate.instant('Sellers.Products.UnableToEdit')
      );
    } else {
      this.router.navigate([
        `${ProductRoutes[product.productTypeName]}/edit/` + product.id,
      ]);
    }
  }

  async selectionActionsCB(event: any) {
    switch (event.action) {
      case "delete":
        this.delete();
        break;
      case "publish":
        this.publish();
        break;
      case "unpublish":
        this.unPublish();
        break;
    }
  }

  async delete() {
    try {
      const productsIdArray = this.selection.selected.map(
        product => product.id
      );
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        data: {
          message: this.translate.instant('Sellers.Products.SureWantDelete'),
          question: true,
          confirmTextMessage: this.translate.instant('Sellers.Products.Yes'),
          cancelTextMessage: this.translate.instant('Sellers.Products.No')
        }
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }
      this.DeleteProductService.setParams({ productsIdArray: productsIdArray });
      const response = await this.DeleteProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.DeleteProducts'),
        content: this.translate.instant('Sellers.Products.DeleteSuccessfully'),
        closeButtonName: this.translate.instant('Sellers.Products.Close')
      };
      this.modal.open(modalData);
      this.updateTable();
      this.getFilteredProductsService
        .loader()
        .subscribe((val: any) => {
          this.loading = val;
        });
    } catch (err) {
      console.log(err);
    }
  }

  async publish() {
    try {
      const productsIdArray = this.selection.selected.map(
        product => product.id
      );
      this.PublishProductService.setParams({
        productsIdArray: productsIdArray
      });
      const response = await this.PublishProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.PublishProducts'),
        content: this.translate.instant('Sellers.Products.PublishSuccessfully'),
        closeButtonName: this.translate.instant('Sellers.Products.Close')
      };
      this.modal.open(modalData);
    } catch (err) {
      console.log(err);
    }
  }

  async unPublish() {
    try {
      const productsIdArray = this.selection.selected.map(
        product => product.id
      );
      this.UnPublishProductService.setParams({
        productsIdArray: productsIdArray
      });
      const response = await this.UnPublishProductService.make();
      console.log('response message', response.message);
      const modalData: ModalData = {
        title: this.translate.instant('Sellers.Products.UnpublishProducts'),
        content: this.translate.instant('Sellers.Products.UnpublishSuccessfully'),
        closeButtonName: this.translate.instant('Sellers.Products.Close')
      };
      this.modal.open(modalData);
    } catch (err) {
      console.log(err);
    }
  }

  async view(product: any) {
    await this.router.navigate([`${product.code}`]);
    //window.location.reload();
  }

  openCongratulationDialoug(product: any) {
    //console.log("url ", window.location.origin);
    const dialogRef = this.dialog.open(CongratulationComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: `${window.location.origin}/${product.code}`,
        name: product.productName,
        type: this.productTypeMap[product.productTypeId],
        showCongratulation: false
      }
    });
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.getFilteredProductsService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.getFilteredProductsService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.getFilteredProductsService
        .loader()
        .subscribe((val: any) => {
          this.loading = val;
        });
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.getFilteredProductsService
      .loader()
      .subscribe((val: any) => {
        this.loading = val;
      });
  }

  async updateTable() {
    this.getFilteredProductsService.activateLoader();
    this.selection.clear();
    this.getFilteredProductsService.setParams(this.requestBody);
    const report = await this.getFilteredProductsService.make();
    this.productManagementReportData = report.result.map((p: any) => {
          if ((!p.productName || p.productName == "") && p.paymentMethod != "Cash Api") {
            p.productName = `Quick Payment ${p.customPaymentAmount}`;
          }
          return p;
        });
    //console.log('productManagementReportData', this.productManagementReportData);
    if (localStorage.getItem('language') === 'ar') {
      this.productManagementReportData.forEach((product: any) => {
        switch (product.productTypeName) {
          case "Physical Product":
            product.productTypeName = "المنتج المادى";
            break;
          case "Invoice":
            product.productTypeName = "الفاتورة";
            break;
          case "Event":
            product.productTypeName = "الفعاليات";
            break;
          case "Quick Payment":
            product.productTypeName = "الدفع السريع";
            break;
          case "Quick Cash":
            product.productTypeName = "النقد السريع";
            break;
          case "Subscription":
            product.productTypeName = "الاشتراك";
            break;
          case "Calendar":
            product.productTypeName = "النتيجة";
            break;
          case "Custom Payment":
            product.productTypeName = "الدفع المخصص";
            break;
          // case "Quick Qassatly":
          //   product.productTypeName = "خدمة قسّطلي السريعة";
          //   break;
          default:
            break;
        }
      })
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.productManagementReportData.forEach((product: any) => {
          switch (product.productTypeName) {
            case "Physical Product":
              product.productTypeName = "المنتج المادى";
              break;
            case "Invoice":
              product.productTypeName = "الفاتورة";
              break;
            case "Event":
              product.productTypeName = "الفعاليات";
              break;
            case "Quick Payment":
              product.productTypeName = "الدفع السريع";
              break;
            case "Quick Cash":
              product.productTypeName = "النقد السريع";
              break;
            case "Subscription":
              product.productTypeName = "الاشتراك";
              break;
            case "Calendar":
              product.productTypeName = "النتيجه";
              break;
            case "Custom Payment":
              product.productTypeName = "الدفع المخصص";
              break;
            // case "Quick Qassatly":
            //   product.productTypeName = "خدمة قسّطلي السريعة";
            //   break;
            default:
              break;
          }
        })
      }
    });
    this.mapResponse();
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  mapResponse() {
    for (let index = 0; index < this.productManagementReportData.length; index++) {
      this.productManagementReportData[index].productStatus = this.productStatus[this.productManagementReportData[index].productStatus];
    }
  }
}

interface FieldValueModel {
  id?: number;
  fieldValue?: string;
  createdAt?: string;
  updatedAt?: string;
  ProductId?: number;
  FieldId?: number;
  Field?: FieldModel;
}

interface FieldModel {
  id?: number;
  name?: string;
  width?: number;
  createdAt?: string;
  updatedAt?: string;
  FieldType?: FieldTypeModel;
}

interface FieldTypeModel {
  id?: number;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
}
